import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { isMobileOnly } from "react-device-detect";
import LocalizedStrings from 'react-localization';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventCustomer.css';
import Tag from '../../Common/Tag/Tag';
import StateOptions from '../../Common/StateOptions/StateOptions';
import ProvinceOptions from '../../Common/ProvinceOptions/ProvinceOptions';
import CountryOptions from '../../Common/CountryOptions/CountryOptions';
import PayWithCard from '../../Common/PayWithCard/PayWithCard';
import AutocompleteInput from '../../Common/AutocompleteInput/AutocompleteInput';
import MobileBasketSummary from '../../Common/MobileBasketSummary/MobileBasketSummary';
import Message from '../../Common/Message/Message';
//import StripePayment from '../../Common/StripePayment/StripePayment';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            physicalMailingValidationObject: {
                address_1: {
                    value: '',
                    key: 'customer',
                    name: 'address_1',
                    validationRegEx: '(^(?!\\s*$).+)'
                },
                city: {
                    value: '',
                    key: 'customer',
                    name: 'city',
                    validationRegEx: '(^(?!\\s*$).+)'
                },
                zip: {
                    value: '',
                    key: 'customer',
                    name: 'zip',
                    validationRegEx: '(^\\d{5}(-\\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\\d{1}[A-Za-z]{1} *\\d{1}[A-Za-z]{1}\\d{1}$)'
                },
                phone: {
                    value: '',
                    key: 'customer',
                    name: 'phone',
                    validationRegEx: '(^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$)'
                }
            }
        }
    }

    componentDidMount() {
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const inputs = [].slice.call(document.querySelectorAll('.showtix-input'));
        inputs.forEach((input, i) => {
            input.autocomplete = isChrome ? 'disabled' :  'off';
        });
    }

    validatePhysicalMailing = (bool, e) => {
        e.persist();
        const physicalMailingValidationObject = { ...this.state.physicalMailingValidationObject };
        for (let key in physicalMailingValidationObject) {
            physicalMailingValidationObject[key]['value'] = this.props.customer[key];
        }
        if (bool) {
            for (let key in physicalMailingValidationObject) {
                this.props.validate(
                    physicalMailingValidationObject[key]['value'],
                    physicalMailingValidationObject[key]['key'],
                    physicalMailingValidationObject[key]['name'],
                    physicalMailingValidationObject[key]['validationRegEx'],
                    e
                );
            }
        } else {
            this.props.invalidatePhysicalMailing(Object.keys(physicalMailingValidationObject));
        }
    }

    doesValidationScenarioPass = () => {
        if (this.props.billing.method === 'reserved' || this.props.billing.method === 'vipatron') {
            if(this.props.validation.customer.first_name.valid && this.props.validation.customer.last_name.valid && this.props.validation.customer.email.valid) {
                return false;
            } else {
                return true;
            }
        } else if (this.props.billing.method === 'cash') {
            if ((this.props.customer.mailing_list === true && this.props.client.collect_cust_info === true) || this.props.fees_and_discounts.shipping === 'mail') {
                return !this.props.isReadyToSubmit;
            } else {
                return false;
            }
        } else if (this.props.billing.method === 'card') {
            if ((this.props.customer.mailing_list === true && this.props.client.collect_cust_info === true) || this.props.fees_and_discounts.shipping === 'mail') {
                return !this.props.isReadyToSubmit;
            } else {
                if (this.props.validation.customer.first_name.valid && this.props.validation.customer.last_name.valid && this.props.validation.customer.email.valid) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
    
    displayCustomerAddress = () => {
        if ((this.props.customer.mailing_list === true && this.props.client.collect_cust_info === true) || this.props.fees_and_discounts.shipping === 'mail') {
            return true;
        } else {
            return false;
        }
    }

    renderCustomerSearch = () => {
        if (this.props.user.role) {
            return (
                <React.Fragment>       
                    <div className="row">
                        <div className="col-12">
                            <label className="showtix-label" htmlFor="customer_search">{strings.search}</label>
                        </div>
                    </div>    
                    <div className="row text-left">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <div className="showtix-form__input">
                                    <input
                                        type="text"
                                        className="showtix-input"
                                        id="customer_search"
                                        object="customer" 
                                        name="search"
                                        value={this.props.customer.search}
                                        onChange={this.props.handleCustomerInformation}
                                    />
                                </div>
                                {this.props.customers && this.props.customers.length === 0 &&
                                    <div className="showtix-note">
                                        {strings.noResults}
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="col-12 col-md-3">
                            <button 
                                type="button"
                                className="showtix-button showtix-background__primary-1"
                                disabled={this.props.customer.search === ''}
                                onClick={() => this.props.searchCustomers(this.props.customer.search)}
                            >
                                <span>{strings.searchButton}</span>
                            </button>
                        </div>

                        {this.props.customers && this.props.customers.map((customer, i) => {
                            return <div key={i} className="col-12 col-md-6">
                                <p>
                                    <span className="showtix-user-info">
                                    {customer.first_name}&nbsp;
                                    {customer.last_name}
                                    <br />
                                    {customer.address_1 !== '' &&
                                        <span>{customer.address_1}</span>
                                    }
                                    {customer.city !== '' &&
                                        <span>{customer.city}</span>
                                    }
                                    {customer.state !== '' &&
                                        <span>{customer.state}</span>
                                    }
                                    {customer.country}
                                    <br />
                                    {customer.phone}
                                    <br />
                                    {customer.email}
                                    <br />
                                    </span>
                                    <button
                                        className="showtix-button showtix-button__xsmall showtix-background__primary-2 mt-2"
                                        onClick={() => this.props.selectCustomer(i)}   
                                    >
                                        {strings.selectThisCustomer}
                                    </button>
                                </p>
                            </div> 
                        })}

                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    renderCustomerInfo = () => {
        return (
            <React.Fragment>
                <div className="row text-left">
                    <div className="col-12 text-center">
                        {this.props.is_client &&
                            <h2 className="showtix-h1">
                                {this.props.isCustomerEditingMode === false ? strings.newCustomer : strings.existingCustomer}
                            </h2>
                        }
                        {this.props.isCustomerEditingMode === true &&
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-1"
                                onClick={this.props.toggleCustomerEditingMode}    
                            >{strings.clear}</button>
                        }
                    </div>
                
                    <div className="col-12 col-md-6">
                        <div className={"showtix-form__group " + (this.props.validation.customer.email.valid === false && this.props.customer.email !== '' ? 'showtix-form__error' : '')}>
                            <label className="showtix-label" htmlFor="customer_email">
                                {strings.email}
                                {!this.props.user.role && '*'}
                            </label>
                            <div className="showtix-form__input">
                                <input
                                    type="text"
                                    className="showtix-input"
                                    id="customer_email"
                                    object="customer"
                                    name="email"
                                    value={this.props.customer.email}
                                    validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                    onChange={this.props.handleCustomerInformation}
                                    onBlur={this.props.validateRequiredField}
                                    required={!this.props.user.role}
                                    autoComplete="email_new"
                                    aria-invalid={!this.props.validation.customer.email.valid}
                                />
                            </div>
                            <div aria-live="polite">
                                {!this.props.validation.customer.email.valid &&
                                    <div className=" showtix-note error">
                                        {this.props.validation.customer.email.msg}
                                    </div>
                                }
                            </div>
                        </div>
                    </div> 

                    <div className="col-12 col-md-6">
                        <div className={"showtix-form__group " + (this.props.validation.customer.phone.valid === false && this.props.customer.phone !== '' ? 'showtix-form__error' : '')}>
                            <label className="showtix-label" htmlFor="customer-phone">{strings.phone} 
                                <span id={`tooltip-phone`} className="showtix-tooltip">!</span>
                                <Tooltip placement="top" target={`tooltip-phone`}>
                                    {strings.phoneTooltip}
                                </Tooltip></label>
                            <div className="showtix-form__input">
                                <input
                                    ref={this.phoneRef}
                                    type="text"
                                    className="showtix-input"
                                    id="customer-phone"
                                    object="customer"
                                    name="phone"
                                    value={this.props.customer.phone}
                                    validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                    onBlur={this.props.validateRequiredField}
                                    onChange={this.props.handleCustomerInformation}
                                    autoComplete="phone_new"
                                    placeholder="XXX-XXX-XXXX"
                                />
                            </div>
                            {!this.props.validation.customer.phone.valid &&
                                <div className=" showtix-note error">
                                    {this.props.validation.customer.phone.msg}
                                </div>
                            }
                        </div>
                    </div>   
                </div>

                <div className="row text-left">    
                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="customer_first_name">
                                {strings.firstName}
                                {this.props.billing.method !== 'cash' && this.props.billing.method !== 'check' && '*'}
                            </label>
                            <div className="showtix-form__input">
                                <input
                                    type="text"
                                    className="showtix-input"
                                    id="customer_first_name"
                                    object="customer"
                                    name="first_name"
                                    value={this.props.customer.first_name}
                                    validation="(^(?!\s*$).+)"
                                    onChange={this.props.handleCustomerInformation}
                                    onBlur={this.props.validateRequiredField}
                                    required={(this.props.billing.method !== 'cash' && this.props.billing.method !== 'check')}
                                    autoComplete="first_name_new"
                                    aria-invalid={!this.props.validation.customer.first_name.valid}
                                />
                            </div>
                            <div aria-live="polite">
                                {!this.props.validation.customer.first_name.valid &&
                                    <div className=" showtix-note error">
                                    {this.props.validation.customer.first_name.msg}
                                    </div>
                                }
                            </div>
                        </div> 
                    </div>     

                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="customer_last_name">
                                {strings.lastName}
                                {this.props.billing.method !== 'cash' && this.props.billing.method !== 'check' && '*'}
                            </label>
                            <div className="showtix-form__input">
                                <input
                                    type="text"
                                    className="showtix-input"
                                    id="customer_last_name"
                                    object="customer"
                                    name="last_name"
                                    validation="(^(?!\s*$).+)"
                                    value={this.props.customer.last_name}
                                    onChange={this.props.handleCustomerInformation}
                                    onBlur={this.props.validateRequiredField}
                                    required={(this.props.billing.method !== 'cash' && this.props.billing.method !== 'check')}
                                    autoComplete="last_name_new"
                                    aria-invalid={!this.props.validation.customer.last_name.valid}
                                />
                            </div>
                            <div aria-live="polite">
                                {!this.props.validation.customer.last_name.valid &&
                                    <div className=" showtix-note error">
                                    {this.props.validation.customer.last_name.msg}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <hr />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderCustomerAddress = () => {
        if(this.displayCustomerAddress()) {
            return (
                <div className="row text-left">
                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="address_1">{strings.address1}</label>
                            <div className="showtix-form__input">
                                <AutocompleteInput {...this.props} />
                            </div>
                            {!this.props.validation.customer.address_1.valid &&
                                <div className=" showtix-note error">
                                    {this.props.validation.customer.address_1.msg}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="address_2">{strings.address2}</label>
                            <div className="showtix-form__input">
                                <input 
                                    id="address_2"
                                    className="showtix-input" 
                                    type="text" 
                                    object="customer" 
                                    name="address_2" 
                                    value={this.props.customer.address_2}
                                    onChange={this.props.handleCustomerInformation}
                                    autoComplete="address_2_new"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="city">{strings.city}</label>
                            <div className="showtix-form__input">
                                <input 
                                    id="city"
                                    className="showtix-input" 
                                    type="text" 
                                    object="customer" 
                                    name="city" 
                                    validation="(^(?!\s*$).+)"
                                    value={this.props.customer.city}
                                    onBlur={this.props.validateRequiredField}
                                    onChange={this.props.handleCustomerInformation}
                                    required
                                    autoComplete="city_new"
                                />
                            </div>
                            {!this.props.validation.customer.city.valid &&
                                <div className=" showtix-note error">
                                    {this.props.validation.customer.city.msg}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="country">{strings.country}</label>
                            <div className="showtix-form__select">
                                <select className="showtix-input"
                                    object="customer"
                                    name="country"
                                    id="country"
                                    value={this.props.customer.country}
                                    onChange={this.props.handleCustomerInformation}
                                    autoComplete="country_new"
                                >
                                    <CountryOptions />
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="state">{strings.state}</label>
                            <div className="showtix-form__select">
                                {this.props.customer.country === 'US' || this.props.customer.country === '' ?
                                    <select className="showtix-input"
                                        object="customer"
                                        name="state"
                                        id="state"
                                        value={this.props.customer.state}
                                        onChange={this.props.handleCustomerInformation}
                                        autoComplete="state_new"
                                    >
                                        <StateOptions />
                                    </select>
                                    :
                                    <select 
                                        className="showtix-input" 
                                        object="customer" 
                                        name="state" 
                                        value={this.props.customer.state}
                                        onChange={this.props.handleCustomerInformation}
                                        autoComplete="state_new"
                                    >
                                        <ProvinceOptions />
                                    </select>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className={"showtix-form__group " + (this.props.validation.customer.zip.valid === false && this.props.customer.zip !== '' ? 'showtix-form__error' : '')}>
                            <label className="showtix-label" htmlFor="zip">{strings.zip}</label>
                            <div className="showtix-form__input">
                                <input
                                    id="zip"
                                    type="text"
                                    className="showtix-input"
                                    object="customer"
                                    name="zip"
                                    value={this.props.customer.zip}
                                    validation="(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)"
                                    onBlur={this.props.validateRequiredField}
                                    onChange={this.props.handleCustomerInformation}
                                    required
                                    autoComplete="zip_new"
                                />
                            </div>
                            {!this.props.validation.customer.zip.valid &&
                                <div className=" showtix-note error">
                                    {this.props.validation.customer.zip.msg}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-12">
                        <hr />
                    </div>
                </div>
            );
        }
    }

    renderTags = () => {
        if (this.props.tags.length > 0) {
            return (
                <div className="row text-left">
                    <div className="col-12">
                        <div className="showtix-form__group" style={{height:'auto'}}>
                            <label className="showtix-label">{strings.describe}</label>
                        </div>
                        <div className="d-flex flex-wrap showtix-event-tags">
                            {this.props.tags.filter(tag => tag.active).map((tag, i) => {
                                return <Tag
                                        key={i}
                                        object="tags"
                                        id={"tag-" + i}
                                        value={tag.id}
                                        name={tag.tag_name}
                                        handleChangeFilter={() => this.props.handleChangeFilter(tag.id, tag.tag_name)}
                                        isActive={this.props.selectedTags.indexOf(tag) !== -1}
                                        isReset={this.props.isReset}
                                    />
                                })
                            }
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <div className="showtix-customerInfo" id="customer-info">
                <div className={"showtix-customerInfo__content " + (this.props.isCustomerInfoOpen ? 'is-active' : '')}>
                    <div className="showtix-background__primary-4 showtix-section">
                        <div className="row">
                            <div className="col-12 text-center">
                                <button
                                    className="showtix-button showtix-button__xsmall showtix-background__grey-3"
                                    onClick={() => this.props.toggleCustomerInfo(false)}
                                    aria-label="Go Back to Billing information"
                                >{strings.goBack}</button>
                                <h2 className="showtix-h1">{strings.title}</h2>
                            </div>
                        </div> 

                        {this.renderCustomerSearch()}
                        {this.renderCustomerInfo()}

                        <div className="row text-left">
                            {this.props.client.collect_cust_info &&
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label">{strings.formatString(strings.physicalMailing, { 'client_name': this.props.client.client_name})}</label>

                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="showtix-form__radio">
                                                    <input
                                                        type="radio"
                                                        className="showtix-input"
                                                        id="physical-1"
                                                        object="customer"
                                                        name="mailing_list"
                                                        value="true"
                                                        checked={this.props.customer.mailing_list === true}
                                                        onChange={(e) => {
                                                            this.validatePhysicalMailing(true, e);
                                                            this.props.handleCustomerInformation(e);
                                                        }}
                                                    />
                                                    <label className="showtix-label" htmlFor="physical-1">{strings.yes}</label>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <div className="showtix-form__radio">
                                                    <input
                                                        type="radio"
                                                        className="showtix-input"
                                                        id="physical-2"
                                                        object="customer"
                                                        name="mailing_list"
                                                        value="false"
                                                        checked={this.props.customer.mailing_list === false}
                                                        onChange={(e) => {
                                                            this.validatePhysicalMailing(false, e); 
                                                            this.props.handleCustomerInformation(e);
                                                        }}
                                                    /> 
                                                    <label className="showtix-label" htmlFor="physical-2">{strings.no}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.formatString(strings.emailList, { 'client_name': this.props.client.client_name})}</label>

                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="email-1"
                                                    object="customer"
                                                    name="email_list"
                                                    value="true"
                                                    checked={this.props.customer.email_list === true}
                                                    onChange={this.props.handleCustomerInformation}
                                                />
                                                <label className="showtix-label" htmlFor="email-1">{strings.yes}</label>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="email-2"
                                                    object="customer"
                                                    name="email_list"
                                                    value="false"
                                                    checked={this.props.customer.email_list === false}
                                                    onChange={this.props.handleCustomerInformation}
                                                /> 
                                                <label className="showtix-label" htmlFor="email-2">{strings.no}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <hr />
                            </div>
                        </div>    

                        {this.props.isCustomerInfoOpen && this.renderCustomerAddress()}
                        {this.renderTags()}

                        {isMobileOnly && this.props.isDisplayCart() && !this.props.isConfirmationOpen &&
                            <MobileBasketSummary
                                {...this.state}
                                {...this.props}
                                deleteFromCart={this.props.deleteFromCart} />
                        }

                        { this.doesValidationScenarioPass() &&
                            <div className="row text-left">
                                <div className="col-12">
                                    <Message
                                        id="submit-error-message"
                                        message={
                                            {
                                                title: '',
                                                content: strings.requiredFields,
                                                type: 'error--2'
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        }

                        <div className="row mt-3">
                            <div className="col-12">
                                <hr />
                            </div>
                            <div className="col-12">
                                
                                {this.props.billing.method !== 'card' || this.props.cartPricing.txn_gross === 0 ?
                                    !this.props.hasQuestionNotAnswered ? (
                                        <button
                                            type="button"
                                            className="showtix-button showtix-background__primary-2"
                                            onClick={this.props.checkout}
                                            disabled={this.doesValidationScenarioPass() || (!this.props.cartItems.length > 0 && this.props.fees_and_discounts.donation === 0)}
                                        >
                                            <span>{strings.checkout}</span>
                                        </button>
                                    ) : (
                                        <div className="showtix-message showtix-message__error--2 is-active" id="submit-error-message">
                                            <div className="showtix-padder">
                                                <p>Please answer the required question(s).</p>
                                            </div> 
                                        </div>        
                                    )
                                    :
                                    (!this.props.hasQuestionNotAnswered) ? (
                                        this.props.validation.customer.phone.valid ? (
                                            <PayWithCard
                                                checkout={this.props.checkout}
                                                customer={this.props.customer}
                                                isDisabled={this.doesValidationScenarioPass()}
                                                returnStripeToken={this.props.returnStripeToken}
                                                cartPricing={this.props.cartPricing}
                                                client={this.props.client}
                                                checkoutInProgress={this.props.checkoutInProgress}
                                            />
                                        ) : (
                                            <div className="showtix-message showtix-message__error--2 is-active text-left" id="submit-error-message">
                                                <div className="showtix-padder">
                                                    <p>Please make sure your phone number is in a valid format XXX-XXX-XXXX.</p>
                                                </div> 
                                            </div> 
                                        )
                                    ) : (
                                        <div className="showtix-message showtix-message__error--2 is-active" id="submit-error-message">
                                            <div className="showtix-padder">
                                                <p>Please answer the required question(s).</p>
                                            </div> 
                                        </div>        
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


EventCustomer.propTypes = {
    customer: PropTypes.shape({
        search: PropTypes.string,
        email: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        address_1: PropTypes.string,
        address_2: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
        phone: PropTypes.string,
        mailing_list: PropTypes.bool,
        email_list: PropTypes.bool
    }),
    validation: PropTypes.shape({
        customer: PropTypes.shape({
            email: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            first_name: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            last_name: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            zip: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            phone: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            })
        })
    }),
    billing: PropTypes.shape({
        method: PropTypes.string
    }),
    tags: PropTypes.array,
    customers: PropTypes.array,
    isCustomerInfoOpen: PropTypes.bool,
    is_client: PropTypes.bool,
    isCustomerEditingMode: PropTypes.bool,
    toggleCustomerInfo: PropTypes.func,
    handleCustomerInformation: PropTypes.func,
    searchCustomers: PropTypes.func,
    selectCustomer: PropTypes.func,
    toggleCustomerEditingMode: PropTypes.func,
    validateRequiredField: PropTypes.func,
    handleChangeFilter: PropTypes.func,
    checkout: PropTypes.func
}

export default EventCustomer;



// WEBPACK FOOTER //
// ./src/components/EventListing/EventCustomer/EventCustomer.js